import { ApiService, convertToFormData } from './api.service';

import Vue from 'vue';
import Axios from 'axios';

export const ShopApiService = {
    query(resource, params, headers = {}) {
        return Vue.prototype.$shop_axios.get(
            resource,
            {
                params: params
            },
            headers
        );
    },

    get(resource, hashid, headers = {}) {
        return Vue.prototype.$shop_axios.get(
            `${resource}/${hashid}`,
            {},
            headers
        );
    },

    post(resource, params, headers = {}) {
        return Vue.prototype.$shop_axios.post(`${resource}`, params, headers);
    },

    update(resource, hashid, params, headers = {}) {
        return Vue.prototype.$shop_axios.post(
            `${resource}/${hashid}`,
            params,
            headers
        );
    },

    put(resource, params, headers = {}) {
        return Vue.prototype.$shop_axios.post(`${resource}`, params, headers);
    },

    delete(resource, hashid) {
        return Vue.prototype.$shop_axios.delete(`${resource}/${hashid}`);
    }
};

// *important* note
// ==> change ApiServices to ShopApiService
// ==> make sure to change $axios instance to $shop_axios instance

export const shopGatewayService = {
    fetch(params) {
        return ShopApiService.query('gateway', params);
    }
};

export const moneyRequestService = {
    find(tracking_code) {
        return ShopApiService.query(`money-request/find/${tracking_code}`);
    },
    create(params) {
        let form_data = convertToFormData(params);
        return ShopApiService.post('money-request/store', form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    getReceiptData(tracking_code) {
        return ShopApiService.query(`money-request/receipt/${tracking_code}`);
    },
    remind(hashid) {
        return ShopApiService.post(`money-request/remind/${hashid}`);
    },
    showItem(hashid) {
        return ShopApiService.query(`item/${hashid}`);
    },
    showCustomer(hashid) {
        return ShopApiService.query(`customer/${hashid}`);
    },
    changeStatus(hashid, params) {
        return ShopApiService.post(
            `money-request/change-status/${hashid}`,
            params
        );
    }
};

export const shopPardakhtShakhsiService = {
    update(params) {
        let form_data = convertToFormData(params);
        return ShopApiService.post('pardakht-shakhsi', form_data);
    }
};

export const ivrService = {
    fetch(params) {
        return ShopApiService.query('ivr', params);
    },
    find(hashid) {
        return ShopApiService.get('ivr/find', hashid);
    },
    create(params) {
        let form_data = convertToFormData(params);
        return ShopApiService.post('ivr/create', form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    update(hashid, params) {
        let form_data = convertToFormData(params);
        return ShopApiService.update('ivr/update', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        });
    },
    updateWallet(hashid, params) {
        return ShopApiService.post(`ivr/update-wallet/${hashid}`, params);
    },
    delete(hashid) {
        return ShopApiService.delete(`ivr/delete/${hashid}`);
    },
    changeStatus(hashid, status) {
        return ShopApiService.post(`ivr/change-status/${hashid}`, {
            status: status
        });
    },
    changeWage(hashid, params) {
        return ShopApiService.post(`ivr/change-wage/${hashid}`, params);
    },
    billInquiry(hashid) {
        return ShopApiService.query(`ivr/bill-inquiry/${hashid}`);
    }
};

// export const moneyRequestService = {
//     find(tracking_code) {
//         return ShopApiService.query(`money-request/find/${tracking_code}`);
//     },
//     create(params) {
//         let form_data = convertToFormData(params);
//         return ShopApiService.post('money-request/store', form_data, {
//             'Content-Type': 'multipart/form-data'
//         });
//     },
//     getReceiptData(tracking_code) {
//         return ShopApiService.query(`money-request/receipt/${tracking_code}`);
//     },
//     remind(hashid) {
//         return ShopApiService.post(`money-request/remind/${hashid}`);
//     },
//     showItem(hashid) {
//         return ShopApiService.query(`item/${hashid}`);
//     },
//     showCustomer(hashid) {
//         return ShopApiService.query(`customer/${hashid}`);
//     },
//     showCustomerFormat(hashid) {
//         return ShopApiService.query(`customer/format/find/${hashid}`);
//     },
//     changeStatus(hashid, params) {
//         return ShopApiService.post(
//             `money-request/change-status/${hashid}`,
//             params
//         );
//     }
// };

export const notificationSmsService = {
    fetch() {
        return ShopApiService.query('notification-sms');
    },
    update(params) {
        let form_data = convertToFormData(params);
        return ShopApiService.post('notification-sms', form_data);
    },
    updatsetSmsPrice(params) {
        let form_data = convertToFormData(params);
        return ShopApiService.post('notification-sms/set-sms-price', form_data);
    },
    updateSmsWallet(params) {
        let form_data = convertToFormData(params);
        return ShopApiService.post(
            'notification-sms/update-sms-wallet',
            form_data
        );
    },
    getRechargeData(tracking_code) {
        return ShopApiService.query(
            `notification-sms/get-recharge-result/${tracking_code}`
        );
    }
};

export const onlineFactorService = {
    showItem(hashid) {
        return ShopApiService.query(`item/${hashid}`);
    },
    showCustomer(hashid) {
        return ShopApiService.query(`customer/${hashid}`);
    },
    showFactor(hashid) {
        return ShopApiService.query(`factor/${hashid}`);
    },
    archiveItem(hashid) {
        return Vue.prototype.$shop_axios.delete(`item/${hashid}/archive`);
    },
    unarchiveItem(hashid) {
        return Vue.prototype.$shop_axios
            .patch(`item/${hashid}/unarchive`)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    deleteItem(hashid) {
        return Vue.prototype.$shop_axios.delete(`item/${hashid}/delete`);
    },
    archiveCustomer(hashid) {
        return Vue.prototype.$shop_axios.delete(`customer/${hashid}/archive`);
    },
    unarchiveCustomer(hashid) {
        return Vue.prototype.$shop_axios
            .patch(`customer/${hashid}/unarchive`)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    deleteCustomer(hashid) {
        return Vue.prototype.$shop_axios.delete(`customer/${hashid}/delete`);
    },
    deleteFactor(hashid) {
        return Vue.prototype.$shop_axios
            .delete(`factor/${hashid}/delete`)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    archiveFactor(hashid) {
        return Vue.prototype.$shop_axios
            .delete(`factor/${hashid}/archive`)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    unarchiveFactor(hashid) {
        return Vue.prototype.$shop_axios
            .patch(`factor/${hashid}/unarchive`)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    createItem(params) {
        let form_data = convertToFormData(params);
        return ShopApiService.post(`item`, form_data);
    },
    createCustomer(params) {
        let form_data = convertToFormData(params);
        return ShopApiService.post(`customer`, form_data);
    },
    createCustomerFormat(params) {
        let form_data = convertToFormData(params);
        return ShopApiService.post(`customer/format`, form_data);
    },
    remindFactor(hashid) {
        return Vue.prototype.$shop_axios
            .post(`factor/sub/${hashid}/reminder`)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    cancelFactor(hashid) {
        return Vue.prototype.$shop_axios
            .patch(`factor/sub/${hashid}/cancel`)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    paymentFactor(hashid, params) {
        return ShopApiService.query(`/factor/pay/${hashid}`, params);
    },
    getPayment(hashid, payment_id) {
        let query = {
            payment_id: payment_id
        }
        return ShopApiService.query(`/factor/payment/${hashid}`, query)
    },
    payMoneyFactor(hashid, params) {
        return ShopApiService.post(`/online-factor/pay/${hashid}`, params);
    },
    factorStatusActive(hashid) {
        return Vue.prototype.$shop_axios
            .patch(`/factor/${hashid}/change-status?status=1`)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    factorStatusDiactive(hashid) {
        return Vue.prototype.$shop_axios
            .patch(`/factor/${hashid}/change-status?status=0`)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    updateCustomer(hashid, data) {
        return Vue.prototype.$shop_axios
            .post(`/customer/${hashid}`, data)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    updateItem(hashid, data) {
        return Vue.prototype.$shop_axios
            .post(`/item/${hashid}`, data)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    factorCustomerSearch(search) {
        return Vue.prototype.$shop_axios
            .get(`/customer/search?q=${search}`)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    getFactorCustomerFormat(search) {
        return ShopApiService.query(`/customer/format`, search)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    factorItemSearch(search) {
        return Vue.prototype.$shop_axios
            .get(`/item/search?q=${search}`)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    createFactor(data) {
        return ShopApiService.post(`/factor`, data);
    },
    fetchFields() {
        return ShopApiService.query('/customer/format/field');
    },
    deleteField(hashid) {
        return ShopApiService.delete(`/customer/format/field`, hashid);
    },
    submitCustomerFormat(form_data) {
        return ShopApiService.post(`/customer/format`, form_data);
    },
    updateCustomerFormat(hashid, data) {
        return ShopApiService.post(`/customer/format/update/${hashid}`, data)
    },
    deleteCustomerFormat(id) {
        return ShopApiService.delete(`/customer/format`, id);
    },
    receipt(sub_factor_id, payment_id) {
        return ShopApiService.query(`/factor/receipt/${sub_factor_id}`, { payment_tracking_number: payment_id })
    },
    createDiscount(data) {
        return ShopApiService.post('/factor/discounts', data)
    },
    deleteDiscount(hashid) {
        return ShopApiService.delete(`/factor/discounts`, hashid)
    },
    showDiscount(hashid) {
        return ShopApiService.query(`/factor/discounts/${hashid}`)
    },
    updateDiscount(hashid, data) {
        return ShopApiService.update('/factor/discounts', hashid, data)
    },
    getDiscount(params) {
        return ShopApiService.query('/factor/discounts', params)
    },
    applyDiscount(code, hashid) {
        return ShopApiService.post(`/factor/discounts/apply/${hashid}`, {
            code: code
        });
    },
    reviewPayment(hashid, params) {
        return ShopApiService.post(`/factor/pay/review/${hashid}`, params)
    },
    factorSubFactor(hashid, params) {
        return ShopApiService.query(`/factor/${hashid}/sub-factors`, params)
    },
    createSubFactorExcel(hashid, params) {
        return ShopApiService.post(`/factor/${hashid}/excel-request`, params)
    }
};

export const walletShareHolderService = {
    shareholderCreate(params) {
        return ApiService.post('shareholder/create', params);
    },
    shareholderUpdate(params, hashid) {
        return ApiService.post(`shareholder/update/${hashid}`, params);
    },
    shareholderDetail(hashid) {
        return ApiService.query(`shareholder/detail/${hashid}`);
    },
    shareholderList() {
        return ApiService.query('shareholder/list');
    },
    shareholderIbanDelete(params) {
        return ApiService.post(
            'wallet/common/delete-shareholder-iban',
            params
        );
    }
};

export const ibanInfo = {
    get(params, hashid) {
        return ApiService.post(
            `wallet/common/get-iban-info/${hashid}`,
            params
        );
    }
};
